import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ServicesGrid.css';

const services = [
  {
    tab: 'one-way',
    emoji: '\u{1F695}',
    iconClass: 'ic-or',
    title: 'One-Way Taxi',
    description: 'Pay only one side, always. No return fare ever. Bihar’s most popular one-way cab service.',
    tag: 'Pay one side only',
    tagClass: 'tag-or',
  },
  {
    tab: 'taxipool',
    emoji: '\u{1F697}',
    iconClass: 'ic-gr',
    title: 'TaxiPool',
    description: 'Share your ride, split the cost. See surcharge reason upfront — no surprises.',
    tag: 'Save up to 40%',
    tagClass: 'tag-gr',
  },
  {
    tab: 'hourly',
    emoji: '⏰',
    iconClass: 'ic-bl',
    title: 'Hourly Rental',
    description: 'Driver stays with you. Multi-stop errands, meetings, hospital visits — all covered.',
    tag: 'From ₹300/hour',
    tagClass: 'tag-bl',
  },
  {
    tab: 'tours',
    emoji: '\u{1F3DB}️',
    iconClass: 'ic-gr',
    title: 'Bihar Tours',
    description: 'Bodh Gaya, Rajgir, Nalanda & more. Curated packages with experienced local drivers.',
    tag: 'From ₹2,500/day',
    tagClass: 'tag-gr',
  },
  {
    tab: 'wedding',
    emoji: '\u{1F48D}',
    iconClass: 'ic-pu',
    title: 'Wedding Fleet',
    description: 'Decorated vehicles, all-event coverage, bulk rates. Make your shaadi stress-free.',
    tag: 'From ₹1,800/vehicle',
    tagClass: 'tag-pu',
  },
  {
    tab: 'shifting',
    emoji: '\u{1F4E6}',
    iconClass: 'ic-am',
    title: 'House Shifting',
    description: 'Porter-style service with GPS-tracked trucks and a trained loading team.',
    tag: '✦ New in Bihar',
    tagClass: 'tag-new',
  },
];

const ServicesGrid = () => {
  const navigate = useNavigate();

  const goToBooking = (tab) => {
    if (tab === 'one-way') {
      navigate('/');
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    navigate(`/services?tab=${tab}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="services" id="services">
      <div className="services__container">
        <span className="services__eyebrow">Pick a service to start booking</span>
        <h2 className="services__heading">What would you like to do today?</h2>
        <p className="services__sub">
          Tap any card to jump straight to its booking form &mdash; no extra clicks.
        </p>

        <div className="services__grid">
          {services.map((service) => (
            <button
              key={service.tab}
              type="button"
              className="service-card service-card--clickable"
              onClick={() => goToBooking(service.tab)}
              aria-label={`Book ${service.title}`}
            >
              <div className={`service-card__icon-wrap ${service.iconClass}`}>
                <span className="service-card__emoji">{service.emoji}</span>
              </div>
              <h3 className="service-card__title">{service.title}</h3>
              <p className="service-card__description">{service.description}</p>
              <span className={`service-card__tag ${service.tagClass}`}>
                {service.tag}
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesGrid;
